import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@mui';
import { colors } from '@constants/colors';

import { CARD_STATE_LOADING } from '../constants';
import DashboardContext from '../dashboard-context';
import { getCardHeight } from '../utils';

import '../dashboard-card.scss';

const CardError = ({ card }) => {
  const { updateCardState } = useContext(DashboardContext);

  const handleRefresh = () => {
    updateCardState(card, CARD_STATE_LOADING);
  };

  const style = {
    buttonLink: {
      appearance: 'none',
      background: 'none',
      border: 'none',
      fontFamily: 'inherit',
      fontSize: 'inherit',
      cursor: 'pointer',
      paddingLeft: '0.25rem',
      paddingTop: 0,
      paddingBottom: 0,
      paddingRight: 0,
      color: colors.brand.blue,
      fontWeight: '500'
    },
    cardBody: {
      height: getCardHeight(card)
    }
  };

  return (
    <div style={style.cardBody} styleName="card-body-empty">
      <div>
        <Icon style={{ fontSize: '2rem' }} color={colors.neutral.ash} aria-hidden="true">
          warning
        </Icon>
      </div>
      <div>
        Cannot Load Data.
        <button type="button" style={style.buttonLink} onClick={handleRefresh}>
          Refresh
        </button>
      </div>
    </div>
  );
};

CardError.propTypes = {
  card: PropTypes.object
};

export default CardError;
